// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__aA-K0","icon":"ErrorPage_icon__vG3KU","title":"ErrorPage_title__nAetT","message":"ErrorPage_message__lqUyo","errorBox":"ErrorPage_errorBox__3O3u5"};